import { SharedState } from '@trello/shared-state';

interface PluginBoardBarOptions {
  isOpen: boolean;
}

export const PluginBoardBarState = new SharedState<PluginBoardBarOptions>({
  isOpen: false,
});
